import { enumElementDrawStates } from "../constants";
import { QElement } from "./QElement";
import { SetCtxFont } from "../utils/SetCtxFont";
import { Globals } from "./Globals.js";

export class QDropDownDivider extends QElement {
  constructor() {
    super();
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    SetCtxFont(ctx, this.fFontString);
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.MouseDown:
      case enumElementDrawStates.Hover:
        var txtFillStyle = Globals._themeMode.lightborder;
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }
    ctx.save();
    ctx.globalAlpha = 0.6;
    ctx.fillStyle = txtFillStyle;
    ctx.fillRect(this.fHorzOffset + 6, this.fVertOffset - 1, this.fWidth - 6, 1);
    ctx.restore();
  }
}
